import API from "../api";
import { AxiosResponse } from "axios";

import { Estimate } from "../models/estimate";

const endpoint = "jobs/estimate";

const EstimateService = {
  async getByJobId(jobId?: number, options?: any): Promise<AxiosResponse<Estimate>> {
    return await API.get(`${endpoint}/${jobId}`, { params: options });
  },
};

export default EstimateService;
